"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVCardQRCode = exports.createQRCode = void 0;
const qrcode_1 = require("@cheprasov/qrcode");
const vcard_1 = require("./vcard");
function createQRCode(input, option) {
    var _a, _b, _c, _d;
    const config = {
        fgColor: (_a = option === null || option === void 0 ? void 0 : option.foreground) !== null && _a !== void 0 ? _a : '#000000',
        bgColor: (_b = option === null || option === void 0 ? void 0 : option.background) !== null && _b !== void 0 ? _b : '#ffffff',
        padding: (_c = option === null || option === void 0 ? void 0 : option.padding) !== null && _c !== void 0 ? _c : 1,
        image: (option === null || option === void 0 ? void 0 : option.image)
            ? {
                source: option === null || option === void 0 ? void 0 : option.image.url,
                width: option === null || option === void 0 ? void 0 : option.image.width,
                height: option === null || option === void 0 ? void 0 : option.image.height,
                x: 'center',
                y: 'center',
                border: (_d = option === null || option === void 0 ? void 0 : option.image.border) !== null && _d !== void 0 ? _d : 1,
            }
            : undefined,
        level: 'Q',
    };
    const qrSVG = new qrcode_1.QRCodeSVG(input, config);
    return qrSVG.toString();
}
exports.createQRCode = createQRCode;
function createVCardQRCode(vCardOptions, option) {
    try {
        const vCard = (0, vcard_1.createVCard)(vCardOptions);
        if (!vCard) {
            throw new Error('vCard creation failed');
        }
        return createQRCode(vCard, option);
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
exports.createVCardQRCode = createVCardQRCode;
//# sourceMappingURL=qrcode.js.map